import { AdvancedSearchParams } from "./types";
import FilterChip from "../filterChip";

type BrowseFilterChipsProps = {
  activeFilters: AdvancedSearchParams | null;
  onClearFileType: (fileType: string) => void;
  onClearDateModified: () => void;
  onClearAll: () => void;
};

const BrowseFilterChips = ({
  activeFilters,
  onClearFileType,
  onClearDateModified,
  onClearAll,
}: BrowseFilterChipsProps) => {
  if (!activeFilters) return null;

  const hasFileTypes = activeFilters.fileTypes && activeFilters.fileTypes.length > 0;
  const hasDateFilter = activeFilters.dateModified && activeFilters.dateModified !== "any";

  if (!hasFileTypes && !hasDateFilter) return null;

  const dateLabel =
    activeFilters.dateModified === "last7Days"
      ? "Last 7 days"
      : activeFilters.dateModified === "last30Days"
        ? "Last 30 days"
        : activeFilters.dateModified === "thisYear"
          ? "This year"
          : activeFilters.dateModified === "last3Years"
            ? "Last 3 years"
            : activeFilters.dateModified === "custom" &&
                activeFilters.dateFrom &&
                activeFilters.dateTo
              ? `${activeFilters.dateFrom} to ${activeFilters.dateTo}`
              : activeFilters.dateModified === "custom"
                ? "Custom range"
                : "";

  return (
    <div className="flex flex-wrap gap-2 items-center">
      {activeFilters.fileTypes.length > 0 &&
        activeFilters.fileTypes.map((fileType) => (
          <FilterChip
            key={fileType}
            title="Type"
            label={fileType}
            onClose={() => onClearFileType(fileType)}
          />
        ))}
      {activeFilters.dateModified !== "any" && dateLabel && (
        <FilterChip
          title="Modified"
          label={dateLabel}
          onClose={onClearDateModified}
        />
      )}
      <button
        onClick={onClearAll}
        className="text-sm transition-colors text-gray-600 hover:text-gray-800"
      >
        Clear filters
      </button>
    </div>
  );
};

export default BrowseFilterChips;
